// extracted by mini-css-extract-plugin
export default {"title":"STrgtUWE0NH70jKM2dmk","subtitle":"fKgWotAOs8rPBJJ43yFF","inviteForm":"dHYpoA2WVLwbSlt5HjLN","fadeIn":"wKj_azJwm0Q4SKu_KsrC"};